// Shown while the session is being resolved against /auth/me. Deliberately
// plain: it appears for one request and should not flash branding.
export default function FullPageSpinner() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-lightPrimary dark:!bg-navy-900">
      <div
        className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-brand-500 dark:border-navy-700 dark:border-t-brand-400"
        role="status"
        aria-label="Loading"
      />
    </div>
  );
}
